import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  imageContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    minWidth: '100%',
    minHeight: 580,
    [theme.breakpoints.up('sm')]: {
      minWidth: 270,
      minHeight: 450,
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 250,
      minHeight: 390,
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: 312,
      minHeight: 390,
    },
  },
}));
